import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterArray',
})
export class FilterArrayPipe implements PipeTransform {
	/**
	 *
	 * @param items Array items
	 * @param filter Filtro
	 * @param index Index do array
	 * @returns Array[]
	 */
	transform<T>(items: T[], filter: unknown, index: keyof T): T[] {
		let arrayFilter: T[] = [];
		try {
			if (!filter) {
				return items;
			}
			if (!items) {
				return items;
			}

			const filterValue =
				Array.isArray(filter) && filter.length > 0 ? String(filter[0].value) : String(filter);

			items.forEach((item) => {
				const itemValue = item[index];
				if (
					itemValue != null &&
					String(itemValue).toLowerCase().indexOf(filterValue.toLowerCase()) !== -1
				) {
					arrayFilter.push(item);
				}
			});
		} catch (e) {
			console.error('Erro', e);
			arrayFilter = items;
		}
		return arrayFilter;
	}
}
